var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page__content hotel-package"},[_c(_setup.AppHeader),_vm._v(" "),_c(_setup.PackageLanding)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }